export default __webpack_public_path__ + "static/media/welcome.dbd8bd23.mp4";